import React, { useEffect, useState, useReducer } from 'react';
import { useNavigate } from 'react-router-dom';
import type { TabsProps } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Tabs, Input, Row, Col, Modal, Form, Select, message, Spin } from 'antd';
import api from '@/api/settings';
import dayjs from 'dayjs';
import closeIcon from '@/assets/images/Icons_Cross.png';
import Pagination from '@/components/pagination';
const { TextArea } = Input;
function reducer(state, action) {
    switch (action.type) {
        case 'setLoading':
            return { dataStatus: 'loading' };
        case 'setEmpty':
            return { dataStatus: 'empty' };
        case 'setData':
            return { dataStatus: 'showData' };
        default:
            throw new Error();
    }
}
const Versions = (props: any) => {
    const [listParams, setParams] = useState({ pageNum: 1, deviceType: '1' });
    const [totalRecord, setTotalRecord] = useState(0);
    const [status, setStatus] = useReducer(reducer, {
        dataStatus: 'empty',
    });
    const items: TabsProps['items'] = [
        {
            key: '1',
            label: `Tasker IOS`,
        },
        {
            key: '2',
            label: `Tasker Android`,
        },
    ];
    const [tableData, setTableData] = useState<any[]>([]);
    async function getVersionList() {
        setStatus({ type: 'setLoading' });
        try {
            const res = await api.versionList({ pageSize: 10, ...listParams });
            if (res.data.records.length > 0) {
                setStatus({ type: 'setData' });
                setTableData(res.data.records);
                setTotalRecord(res.data.total);
            } else {
                setStatus({ type: 'setEmpty' });
            }
        } catch (error: any) {
            message.error(error);
            setStatus({ type: 'setEmpty' });
        }
    }
    const handlePageChange = prop => {
        setParams(state => ({ ...state, pageNum: prop }));
    };
    const [uploadVersionForm] = Form.useForm();
    const onFinish = async (values: any) => {
        console.log('Success:', values);
        try {
            await api.versionAdd(values);
            setParams(state => ({ ...state, pageNum: 1 }));
            handleCancel();
        } catch (error: any) {
            message.error(error);
        }
    };

    const onFinishFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo);
        message.error(errorInfo.errorFields[0].errors[0]);
    };
    const onReset = () => {
        uploadVersionForm.resetFields();
    };
    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };
    useEffect(() => {
        if (isModalOpen) {
            uploadVersionForm.setFieldValue('deviceType', listParams.deviceType);
        }
    }, [isModalOpen]);
    const handleCancel = () => {
        onReset();
        setIsModalOpen(false);
    };
    const versionChange = e => {
        e.target.value = e.target.value.replace(/[^\d^\.]/g, '');
    };
    const onChange = (key: string) => {
        setParams({ pageNum: 1, deviceType: key });
    };
    useEffect(() => {
        getVersionList();
    }, [listParams]);
    return (
        <>
            <div className="page-main versions">
                <div className="page-title flex-between">
                    Versions
                    <Button style={{ width: 132 }} type="primary" onClick={showModal}>
                        <PlusOutlined style={{ color: '#fff' }} /> Update
                    </Button>
                </div>
                <div className="select-bar">
                    <Tabs className="version-tabs" defaultActiveKey="1" items={items} onChange={onChange} />
                </div>
                {status.dataStatus === 'loading' ? (
                    <div className="data_loading flex-center">
                        <Spin />
                    </div>
                ) : (
                    <></>
                )}
                {status.dataStatus === 'empty' ? <div className="no-data flex-center">No data</div> : <></>}
                {status.dataStatus === 'showData' ? (
                    <div className="table">
                        <div className="table-th">
                            <Row>
                                <Col span={4}>VERSION</Col>
                                <Col span={4}>MINIMUM VERSION</Col>
                                <Col span={5}>UPLOAD TIME</Col>
                                <Col span={5}>UPLOAD DETAILS</Col>
                            </Row>
                        </div>
                        <>
                            {tableData.map(item => (
                                <Row key={item.version} className="table-tr">
                                    <Col span={4}>V{item.currentVersion}</Col>
                                    <Col span={4}>V{item.minVersion}</Col>
                                    <Col span={5}>{dayjs(new Date(item.updateTime)).format('MMM DD, YYYY')}</Col>
                                    <Col span={5} style={{ whiteSpace: 'pre-line' }}>
                                        {item.versionDescribed ?? '-'}
                                    </Col>
                                </Row>
                            ))}

                            <Pagination total={totalRecord} pageChange={handlePageChange} pageNo={listParams.pageNum} />
                        </>
                    </div>
                ) : (
                    <></>
                )}
            </div>
            <Modal
                width={440}
                maskClosable={false}
                centered={true}
                open={isModalOpen}
                closeIcon={<></>}
                onCancel={handleCancel}
            >
                <div className="modal-title">Upload Version Details</div>
                <div className="split-line"></div>
                <Form
                    name="upload-version-form"
                    className="upload-version-form"
                    form={uploadVersionForm}
                    layout="vertical"
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    validateTrigger="onBlur"
                    autoComplete="off"
                >
                    <Form.Item
                        label="Device"
                        name="deviceType"
                        rules={[{ required: true, message: 'Please select mobile device!' }]}
                    >
                        <Select
                            className="form-select"
                            suffixIcon={
                                <img
                                    src={require('@/assets/images/select-icon.png')}
                                    style={{ width: 24, height: 24 }}
                                />
                            }
                        >
                            <Select.Option value="1">Tasker IOS</Select.Option>
                            <Select.Option value="2">Tasker Android</Select.Option>
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="Version"
                        name="currentVersion"
                        rules={[
                            { required: true, message: 'Please type version!' },
                            { max: 20, message: 'The maximum length of Version is 20' },
                            {
                                pattern: /^[1-9]\d?(\.([1-9]?\d)){2}$/,
                                message: 'The version number format is: X.Y.Z（1-99.0-99.0-99）',
                            },
                        ]}
                    >
                        <Input className="default_input" maxLength={20} onInput={versionChange} />
                    </Form.Item>
                    <Form.Item
                        label="Minimum Version"
                        name="minVersion"
                        rules={[
                            { required: true, message: 'Please type minimum!' },
                            { max: 20, message: 'The maximum length of Minimum is 20' },
                            {
                                pattern: /^[1-9]\d?(\.([1-9]?\d)){2}$/,
                                message: 'The minimum version number format is: X.Y.Z（1-99.0-99.0-99）',
                            },
                        ]}
                    >
                        <Input className="default_input" maxLength={20} onInput={versionChange} />
                    </Form.Item>
                    <Form.Item
                        label="Update Details"
                        name="versionDescribed"
                        rules={[
                            { required: true, message: 'Please type upload details!' },
                            { max: 500, message: 'The maximum length of Upload details is 500' },
                        ]}
                    >
                        <TextArea rows={8} maxLength={500} />
                    </Form.Item>
                    <Form.Item>
                        <div className="flex-center" style={{ marginTop: 24, marginBottom: '-16px', columnGap: 20 }}>
                            <Button danger style={{ flex: 1 }} onClick={handleCancel}>
                                Cancel
                            </Button>
                            <Button type="primary" htmlType="submit" style={{ flex: 1 }}>
                                Submit
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default Versions;
